module.exports = __webpack_public_path__ + "img/qd.264139bc.png";